import ChevronLeft from "@/assets/img/symbolic/chevron-left.svg?react";

function ContextMenu({
    visible,
    onClose,
    children,
}: {
    visible: boolean;
    onClose?: () => void;
    children?: React.ReactNode;
})
{
    return (
        <div
            className={Wind.style({
                position: "fixed",
                inset: "inset-0",
                display: "flex",
                flexDirection: "flex-col",
                alignItems: "items-center",
                justifyContent: "justify-center",
                zIndex: "z-[5000]",
                backgroundColor: "bg-black/50",
                backdropBlur: "backdrop-blur-sm",
                transition: "transition-opacity ease-in-out",
                transitionDuration: "duration-300",
                transitionDelay: "delay-100",
                pointerEvents: visible ? "pointer-events-auto" : "pointer-events-none",
                opacity: visible ? "opacity-100": "opacity-0",
            }).class}
            onClick={(e) =>
            {
                if (e.target === e.currentTarget)
                {
                    onClose?.();
                }
            }}
        >
            <div
                className={Wind.style({
                    position: "absolute",
                    bottom: "bottom-0",
                    left: "left-0",
                    right: "right-0",

                    backgroundColor: "bg-[#1B2F4E]",
                    borderTopRadius: "rounded-t-2xl",
                    paddingX: "px-4",
                    paddingTop: "pt-6",
                    paddingBottom: "pb-[calc(1.5rem_+_var(--safe-area-bottom))]",
                    transformTranslateY: visible ? "translate-y-0" : "translate-y-full",
                    transition: "transition-transform ease-in-out",
                    transitionDuration: "duration-500",
                    pointerEvents: "pointer-events-auto",
                    opacity: visible ? "opacity-100" : "opacity-0",
                    display: "flex",
                    flexDirection: "flex-col",
                    gap: "gap-6",
                }).class}
                onClick={(e) =>
                {
                    e.stopPropagation();
                }}
            >
                <button
                    className={Wind.style({
                        display: "flex",
                        alignItems: "items-center",
                        gap: "gap-2",
                        backgroundColor: "bg-[#1B2F4E]",
                        borderRadius: "rounded-lg",
                        color: "text-[#B3C2DB]",
                        fontSize: "text-base",
                        fontWeight: "font-normal",
                    }).class}
                    onClick={onClose}
                >
                    <ChevronLeft
                        className={Wind.style({
                            width: "w-6",
                            height: "h-6",
                            color: "text-poppy-yellow",
                        }).class}
                        aria-label="Close Context Menu"
                    />
                    Back
                </button>
                <div
                    className={Wind.style({
                        display: "flex",
                        flexDirection: "flex-col",
                        gap: "gap-4",
                    }).class}
                >
                    {children}
                </div>
            </div>
        </div>
    );
}

function MenuItem({
    icon,
    label,
    onClick,
}: {
    icon?: React.ReactNode;
    label?: string;
    onClick?: () => void;
})
{
    return (
        <button
            className={Wind.style({
                display: "flex",
                alignItems: "items-center",
                gap: "gap-2",
                color: "text-white",
            }).class}
            onClick={onClick}
        >
            <span
                className={Wind.style({
                    color: "text-[#B3C2DB]"
                }).class}
            >
                {icon}
            </span>
            <span>
                {label}
            </span>
        </button>
    );
}

ContextMenu.Item = MenuItem;

export default ContextMenu;
